export interface LoginStatus {
  name: string;
  email: string;
  status: string;
  cellPhone: string;
  turnstileRequired?: boolean;
  turnstileSiteKey?: string;
  turnstile?: {
    required?: boolean;
    siteKey?: string;
  };
}

export enum StatusRegisterResponse {
  OK = 'OK',
  UNKNOWN_USER = 'Usuário desconhecido.',
  UNREGISTERED_USER = 'Usuário não registrado',
  INVALID_PASSWORD = 'Senha inválida',
  ALREADY_REGISTERED = 'Usuário já cadastrado.',
  UNKNOWN_ERROR = 'Erro desconhecido. Tente novamente mais tarde.',
  REGISTERED_USER = 'Usuário já cadastrado.'
}

export class PasswordRegistrationResponse {
  email?: string;
  name?: string;
  status?: StatusRegisterResponse;
  success?: boolean;
  dealerMissingAddress?: boolean;
  hasPhoneNumber: boolean;

  get errorMessage(): string {
    if (!this.status || this.status === 'OK') {
      return undefined;
    }
    const result = StatusRegisterResponse[this.status];

    return result ? result : 'UNKNOWN';
  }
}

export class CheckUserOptinResponse {
  success: boolean;
  errorCode?: 'UNAUTHORIZED' | 'INCOMPLETE_INFO' | 'MISSING_OPTIN';
  missingFields?: string[];
}

export interface PasswordRegistrationRequest {
  userId: string;
  verifCode: string;
  password: string;
}

export interface DefaultStatus {
  success: boolean;
  status?: string;
  email?: string;
  message?: string;
  effectiveMarginLimit?: number | null;
}

export interface AcceptNewLoginTermsRequest {
  acceptedNewLogginTerms: boolean;
  whatsappNumber: string;
  whatsappOptin: boolean;
  segmentClassification: string[];
}